<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="specimen-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="80%"
            :selection="true"
            :tableHeight="tableHeight"
            searchPlaceholder="关键字搜索"
            :addButton="{ enabled: false }"
            :filterSpan="[18, 5]"
            :updateButton="{ enabled: false }"
            @loadDeliverView="loadDeliverView"
            @checkThrough="checkThrough"
            @loadCheckFailedView="loadCheckFailedView"
            @rowClick="activRow"
            @selectionChange="loadChecked"
        >
            <template slot="filter">
                <el-col :md="8" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="4" :xl="3">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="wardAuth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="7" :xl="4">
                    <item-input type="multiselect" v-model="specimen_status" :options="sys_enums.SpecimenStatus" :clearable="true" placeholder="请选择标本状态"></item-input>
                </el-col>
            </template>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="loadScanTransView" class="hidden-md-and-down"
                    ><font-awesome-icon :icon="['fas', 'barcode']"></font-awesome-icon>&nbsp;扫码核对送检</el-button
                >
                <el-button type="primary" circle size="mini" @click="loadScanTransView" class="hidden-lg-and-up" title="扫码核对送检">
                    <font-awesome-icon :icon="['fas', 'barcode']"></font-awesome-icon
                ></el-button>
                <el-button type="primary" size="mini" @click="loadBatchTransView" class="hidden-md-and-down" title="批量送检"
                    ><font-awesome-icon :icon="['fas', 'inbox']"></font-awesome-icon>&nbsp;批量送检</el-button
                >
                <el-button type="primary" circle size="mini" @click="loadBatchTransView" class="hidden-lg-and-up"><font-awesome-icon :icon="['fas', 'inbox']"></font-awesome-icon></el-button>
                <el-button type="primary" size="mini" @click="printDocument" class="hidden-md-and-down"><span class="el-icon-printer"></span>&nbsp;打印</el-button>
                <el-button type="primary" circle size="mini" @click="printDocument" title="打印" class="hidden-lg-and-up"><span class="el-icon-printer"></span></el-button>
            </template>
            <div slot="table-title" class="align-left padding5">
                今日标本 {{ this.summary.count }} 个，冰冻{{ this.summary.frozen_section_count }}个 ，待送检{{ this.summary.ready_deliver_count }} 个
            </div>
            <template slot="patient_info" slot-scope="{ row }">
                <div>
                    <b>{{ row.patient_name }}</b>
                    <span class="fg-info">{{ `(${row.visit_no}/${row.ward} ${row.bed_no}床)` }}</span>
                </div>
                <div>主刀医生:{{ row.plan_surgeon }} &nbsp; 器械:{{ row.plan_equipment_nurse || '--' }}&nbsp; 巡回:{{ row.fact_circuit_nurse || '--' }}</div>
            </template>
        </crud-facecade>
        <el-footer style="position: absolute; bottom: 0; background: white; width: 100%; z-index: 99; margin-left: -10px; height: 110px !important">
            <CusStep :steps="transportNode">
                <div slot-scope="{ step }">
                    <div>{{ step.oper }}</div>
                    <div>{{ step.content }}</div>
                </div>
            </CusStep>
        </el-footer>
        <form-dialog title="送检" :visible.sync="deliverView.dialogFormVisible" :data="deliverView.data" :columns="deliverViewColumns" width="25%" @confirm="deliver"></form-dialog>

        <form-dialog
            title="核对不通过"
            :visible.sync="checkFailedView.dialogFormVisible"
            :data="checkFailedView.data"
            :columns="checkFailedView.columns"
            width="40%"
            @confirm="checkFailed"
        ></form-dialog>

        <form-dialog title="批量送检" :visible.sync="batchTransView.dialogFormVisible" :data="batchTransView.data" :columns="batchTransView.columns" width="25%" @confirm="batchDelever"></form-dialog>

        <el-dialog
            title="扫码核对送检"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            v-if="sacnCheckView.dialogFormVisible"
            :visible.sync="sacnCheckView.dialogFormVisible"
            class="table-h560"
            width="90%"
        >
            <item-input type="scan" :autofocus="true" v-model="specimen_id" placeholder="扫码核对送检" @input="scanSpecimen"></item-input>
            <ListView :datalist="sacnCheckView.data" :columns="checkDeliverColumnList" @extrabutton-click="ExtraButtonClick">
                <template slot="patient_info" slot-scope="{ row }">
                    <div>
                        <b>{{ row.patient_name }}</b>
                        <span class="fg-info">{{ `(${row.visit_no}/${row.ward} ${row.bed_no}床)` }}</span>
                    </div>
                    <div>主刀医生:{{ row.plan_surgeon }} &nbsp; 器械:{{ row.plan_equipment_nurse || '--' }}&nbsp; 巡回:{{ row.fact_circuit_nurse || '--' }}</div>
                </template>
            </ListView>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="batchCheckThrough">核对通过</el-button>
                <el-button type="primary" @click="confirmBatchCheck">批量送检</el-button>
                <el-button type="primary" @click="printDocument">打印</el-button>
                <el-button @click="sacnCheckView.dialogFormVisible = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- <form-dialog  title="扫码核对送检" :visible.sync="sacnCheckView.dialogFormVisible"
    :data="sacnCheckView.data" :columns="checkDeliverColumnList" width="25%" @confirm="batchDelever"></form-dialog> -->
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SpecimenTransfer`,
    data() {
        return {
            title: `标本转运`,
            dic_ward_id: undefined,
            specimen_status: [2, 4],
            ischecked: false,
            firstLoad: true,
            summary: {},
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            url: { area: `SpecimenTransfer`,
                baseUrl: ``,
                get: () => {
                    return new Promise((resolve, reject) => {
                        this.loadSpecimens().then(data => {
                            if (this.firstLoad && !this.dic_ward_id && data && data.length > 0) {
                                this.firstLoad = false
                            }
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                } },
            deliverView: {// 送检
                dialogFormVisible: false,
                data: {}
            },
            checkFailedView: {// 核对不通过
                dialogFormVisible: false,
                data: {
                    remark: ``,
                    is_lost: false,
                    name: ``, // 标本名称
                    sampling_position: ``, // 部位
                    identification_code: ``, // 标本号
                    is_lessuse: false // 是否废弃
                },
                columns: [
                    {
                        type: `string`,
                        prop: `name`,
                        label: `标本名称`,
                        colspan: 12,
                        readonly: true
                    },
                    {
                        type: `string`,
                        prop: `sampling_position`,
                        label: `部位`,
                        colspan: 12,
                        readonly: true
                    },
                    {
                        type: `string`,
                        prop: `identification_code`,
                        label: `标本号`,
                        colspan: 24,
                        readonly: true
                    },
                    {
                        type: `textarea`,
                        prop: `remark`,
                        label: `说明`,
                        colspan: 24,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `checkbox`,
                        prop: `is_lost`,
                        label: `标本丢失`,
                        colspan: 12,
                        change: (that, { row, index }) => {
                            if (row.is_lost) {
                                row.is_lessuse = false
                            }
                        }
                    },
                    {
                        type: `checkbox`,
                        prop: `is_lessuse`,
                        label: `标本废弃`,
                        colspan: 12,
                        change: (that, { row, index }) => {
                            if (row.is_lessuse) {
                                row.is_lost = false
                            }
                        }
                    }]
            },
            batchTransView: { // 批量转出
                dialogFormVisible: false,
                data: {
                    p: ``,
                    checkedRow: []
                },
                columns: [{
                    type: `p`,
                    prop: `p`,
                    colspan: 24
                }, {
                    type: `string`,
                    prop: `deliverer`,
                    label: `送检人员`,
                    colspan: 24,
                    default: this.currentUser && this.currentUser.dic_worker_name,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                }, {
                    type: `datetime`,
                    prop: `deliver_date`,
                    label: `送检时间`,
                    colspan: 24,
                    default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }]
            },
            sacnCheckView: {
                dialogFormVisible: false,
                data: []
            },
            transportNode: [],
            transportNodeId: 1,
            specimensData: [],
            specimen_id: null,
            specimes_list: []
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `currentUser`, `ward_auth`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 300) || 0
        },
        wardAuth() {
            this.dic_ward_id = this.active_ward && this.active_ward.value
            return this.ward_auth
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isKey: true
            }, {
                type: `custom`,
                prop: `patient_info`,
                label: `患者信息`,
                width: `300`,
                isListable: true
            }, {
                type: `string`,
                prop: `patient_name`,
                label: `患者姓名`,
                queryable: true
            }, {
                type: `string`,
                prop: `application_number`,
                label: `申请编号`,
                queryable: true
            }, {
                type: `string`,
                prop: `identification_code`,
                label: `标本袋码`,
                queryable: true
            }, {
                type: `string`,
                prop: `surgery_info`,
                label: `手术间`,
                isListable: true
            }, {
                type: `string`,
                prop: `patient_name`,
                label: `患者姓名`,
                isListable: false,
                queryable: true
            }, {
                type: `string`,
                prop: `ward`,
                label: `科室`,
                width: `100`,
                isListable: false
            }, {
                type: `string`,
                prop: `bed_no`,
                label: `床号`,
                width: `60`,
                isListable: false
            }, {
                type: `string`,
                prop: `visit_no`,
                label: this.T(`specimen_transfer.visit_no`),
                isListable: false
            }, {
                type: `string`,
                prop: `name`,
                label: `标本名称`,
                isListable: true
            }, {
                type: `string`,
                prop: `quantity`,
                label: `标本数量`,
                isListable: true
            }, {
                type: `select`,
                prop: `is_frozen_section`,
                label: `冰冻切片`,
                isListable: true,
                options: `enum_bool`
            }, {
                type: `string`,
                prop: `plan_surgeon`,
                label: `主刀医生`,
                isListable: false
            }, {
                type: `string`,
                prop: `plan_equipment_nurse`,
                label: `器械护士`,
                isListable: false
            }, {
                type: `string`,
                prop: `fact_circuit_nurse`,
                label: `巡回护士`,
                isListable: false
            }, {
                type: `datetime`,
                prop: `tissue_in_vitro_date`,
                label: `离体时间`,
                width: `120`,
                isListable: true,
                sortable: `desc`
            }, {
                type: `string`,
                prop: `specimen_deliver_location`,
                label: `标本位置`,
                isListable: true
            }, {
                type: `select`,
                prop: `enum_specimen_status`,
                label: `标本状态`,
                width: `100`,
                isListable: true,
                // searchable: true,
                options: this.sys_enums.SpecimenStatus
            }, {
                type: `datetime`,
                prop: `deliver_dt`,
                label: `送检时间`,
                width: `120`,
                isListable: true
            }, {
                type: `string`,
                prop: `deliverer`,
                label: `送检人员`,
                isListable: true
            },
            {
                type: `string`,
                prop: `batch_no`,
                label: `批次号`,
                sortable: `asc`,
                isListable: true
            },
            {
                type: `string`,
                prop: `sampling_position`,
                label: `部位`,
                isListable: false
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `180`,
                isListable: true,
                readonly: false,
                fixed: `right`,
                options: function(that, { row }) {
                    if (row.enum_specimen_status == 4) {
                        return [{
                            class: `is-plain`,
                            label: `送检`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadDeliverView`,
                            permission: `default`
                        }]
                    } else if (row.enum_specimen_status == 2) {
                        return [{
                            class: `is-plain`,
                            label: `核对通过`,
                            icon: ``,
                            type: `primary`,
                            emit: `checkThrough`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `核对不通过`,
                            icon: ``,
                            type: `danger`,
                            emit: `loadCheckFailedView`,
                            permission: `default`
                        }]
                    } else if (row.enum_specimen_status == 8 || row.enum_specimen_status == 32) {
                        return [{
                            class: `is-plain`,
                            label: `核对通过`,
                            icon: ``,
                            type: `primary`,
                            emit: `checkThrough`,
                            permission: `default`
                        }// ,
                        // {
                        //     class: `is-plain`,
                        //     label: `核对不通过`,
                        //     icon: ``,
                        //     type: `danger`,
                        //     emit: `loadCheckFailedView`,
                        //     permission: `default`
                        // }
                        ]
                    }
                    return []
                },
                config: {
                    align: `flex-start`
                }
            }]
        },
        deliverViewColumns() {
            return [{
                type: `p`,
                prop: `p1`,
                colspan: 24
            }, {
                type: `string`,
                prop: `deliverer`,
                label: `送检人员`,
                colspan: 24,
                default: this.currentUser && this.currentUser.dic_worker_name,
                validate: [{ required: true, message: `必填项目`, trigger: `change` }]
            }, {
                type: `datetime`,
                prop: `deliver_date`,
                label: `送检时间`,
                colspan: 24,
                default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }]
        },
        checkDeliverColumnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isKey: true
            }, {
                type: `custom`,
                prop: `patient_info`,
                label: `患者信息`,
                width: `300`,
                isListable: true
            }, {
                type: `string`,
                prop: `surgery_info`,
                label: `手术间`,
                isListable: true
            }, {
                type: `string`,
                prop: `name`,
                label: `标本名称`,
                isListable: true
            }, {
                type: `string`,
                prop: `quantity`,
                label: `标本数量`,
                isListable: true
            }, {
                type: `select`,
                prop: `is_frozen_section`,
                label: `冰冻切片`,
                isListable: true,
                options: `enum_bool`
            }, {
                type: `datetime`,
                prop: `tissue_in_vitro_date`,
                label: `离体时间`,
                width: `120`,
                isListable: true,
                sortable: `desc`
            }, {
                type: `string`,
                prop: `specimen_deliver_location`,
                label: `标本位置`,
                isListable: true
            }, {
                type: `select`,
                prop: `enum_specimen_status`,
                label: `标本状态`,
                width: `100`,
                isListable: true,
                options: this.sys_enums.SpecimenStatus
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `260`,
                isListable: true,
                readonly: false,
                options: [{
                    class: `is-plain`,
                    label: `移除`,
                    icon: ``,
                    type: `danger`,
                    emit: `removeScanChckView`,
                    permission: `default`
                }]
            }]
        }
    },
    mounted() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    methods: {
        loadSpecimens() {
            return new Promise((resolve, reject) => {
                let that = this
                let req = that.myaxios.get(`/api/Nursing/Specimen/Get?begin=${that.rdate[0]}&end=${that.rdate[1]}`)
                let req2 = this.myaxios.get(`/api/Nursing/Specimen/Summary?begin=${that.rdate[0]}&end=${that.rdate[1]}`)
                let req3 = this.myaxios.get(`/api/Nursing/Specimen/Summary?begin=${this.$moment().format(`YYYY/MM/DD`)}&end=${this.$moment().add(1, `days`).format(`YYYY/MM/DD HH:mm:ss`)}`)
                this.myaxios.all(req, req2, req3).then(([data, summary, summary1]) => {
                    let specimens = _.filter(data, d => {
                        return (that.dic_ward_id && (that.dic_ward_id == `ow_${d.surgery_info.dic_operating_ward_id}` || that.dic_ward_id == `rw_${d.surgery_info.dic_recovery_ward_id}`) || !this.dic_ward_id) &&
              (that.specimen_status.length > 0 && _.includes(that.specimen_status, d.enum_specimen_status) || that.specimen_status.length == 0)
                    }).map(d => {
                        let wardid = (d.surgery_info.dic_operating_ward_id && `ow_${d.surgery_info.dic_operating_ward_id}`) ||
              (d.surgery_info.dic_recovery_ward_id && `rw_${d.surgery_info.dic_recovery_ward_id}`)
                        return {
                            id: d.id,
                            wardid: wardid,
                            application_number: d.application_number,
                            patient_name: d.surgery_info && d.surgery_info.patient_name,
                            ward: d.surgery_info && d.surgery_info.dic_section,
                            bed_no: d.surgery_info && d.surgery_info.bed_no,
                            visit_no: d.surgery_info && d.surgery_info.visit_no,
                            name: d.name,
                            quantity: d.quantity,
                            is_frozen_section: d.is_frozen_section,
                            plan_surgeon: d.surgery_info && d.surgery_info.surgeon,
                            plan_equipment_nurse: d.surgery_info && d.surgery_info.equipment_nurse,
                            fact_circuit_nurse: d.surgery_info && d.surgery_info.circuit_nurse,
                            tissue_in_vitro_date: d.tissue_in_vitro_date,
                            specimen_deliver_location: d.enum_specimen_status == 1 ? d.surgery_info && d.surgery_info.dic_operating_room : d.specimen_deliver_location,
                            specimen_status: d.specimen_status,
                            enum_specimen_status: d.enum_specimen_status,
                            deliver_dt: d.deliver_date,
                            deliverer: d.deliverer,
                            surgery_info: d.surgery_info.dic_operating_room,
                            biz_surgery_info_id: d.biz_surgery_info_id,
                            identification_code: d.identification_code,
                            sampling_position: d.sampling_position,
                            batch_no: d.batch_no
                        }
                    })
                    this.summary = summary
                    this.summary.count = summary1.count
                    this.summary.frozen_section_count = summary1.frozen_section_count
                    this.summary.ready_deliver_count = summary1.ready_deliver_count
                    this.specimes_list = specimens
                    resolve(specimens)
                }).catch(e => reject(e))
            })
        },
        loadDeliverView({ row: specimen }) {
            this.deliverView.data = specimen
            this.deliverView.data.deliver_date = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            this.deliverView.data.p1 = `共转出${specimen.quantity}个，送往病理科`
            this.deliverView.dialogFormVisible = true
        },
        deliver(specimen) {
            // ACIS-24077标本转运，已核对标本，批量送检操作能标记一起批量送检的标本
            let reqBatch = this.myaxios.get(`api/AcisSystem/SystemServer/CreateSerialNum?name=Specimen`)
            reqBatch.then(data => {
                let req = this.myaxios.put(`/api/Nursing/Specimen/Deliver`, {
                    id: specimen.id,
                    deliverer: specimen.deliverer,
                    deliver_date: specimen.deliver_date,
                    enum_specimen_deliver_location: 2, // 2病理科  1标本间
                    biz_surgery_info_id: specimen.biz_surgery_info_id,
                    batch_no: data
                })
                req.then(data => {
                    this.$refs[`specimen-list`].ReloadListData()
                    this.active_id = data.id
                    this.loadTransNode()
                    this.deliverView.dialogFormVisible = false
                }).catch(e => { console.log(e) })
            }).catch(e => { console.log(e) })
        },
        checkThrough({ row: specimen }) {
            specimen.enum_specimen_status = 4
            let req = this.myaxios.put(`/api/Nursing/Specimen/Check`, specimen)
            req.then(data => {
                specimen.enum_specimen_status = 4
                let c = _.find(this.batchTransView.data.checkedRow, { id: specimen.id })
                if (c) { c.enum_specimen_status = 4 }
                this.active_id = data.id
                this.loadTransNode()
                this.$refs[`specimen-list`].ReloadListData()
            }).catch(e => { console.log(e) })
        },
        loadCheckFailedView({ row: specimen }) {
            this.checkFailedView.data = {
                origion: specimen,
                name: specimen.name,
                identification_code: specimen.identification_code,
                sampling_position: specimen.sampling_position,
                remark: ``
            }
            this.checkFailedView.dialogFormVisible = true
        },
        ExtraButtonClick(target) {
            let e = {};
            ({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(target.emit, e)
            }
        },
        loadScanTransView() {
            this.sacnCheckView.data = []
            this.sacnCheckView.dialogFormVisible = true
        },
        checkFailed(specimen) {
            let req = this.myaxios.put(`/api/Nursing/Specimen/Check`, {
                id: this.checkFailedView.data.origion.id,
                enum_specimen_status: specimen.is_lost ? 32 : 8,
                remark: specimen.remark,
                biz_surgery_info_id: this.checkFailedView.data.origion.biz_surgery_info_id,
                is_lessuse: specimen.is_lessuse
            })
            req.then(data => {
                this.checkFailedView.data.origion.enum_specimen_status = specimen.is_lost ? 32 : 8
                this.checkFailedView.dialogFormVisible = false
                this.active_id = data.id
                this.loadTransNode()
            }).catch(e => { console.log(e) })
        },
        activRow({ row }) {
            this.active_id = row && row.id
            this.loadTransNode()
        },
        loadTransNode() {
            if (!this.active_id) return
            let req = this.myaxios.get(`/api/Nursing/Specimen/TransportNodes/${this.active_id}`)
            req.then(data => {
                this.transportNode = _.reduce(data, function(result, value, index) {
                    value.title = value.name
                    value.status = value.is_active ? `primary` : `info`
                    value.occur_time = value.occur_date
                    result.push(value)
                    if (value.sibling_node !== null) {
                        result.push({
                            title: value.sibling_node.name,
                            status: value.is_active ? `primary` : `info`,
                            occur_time: value.sibling_node.occur_date || value.occur_date
                        })
                    }
                    return result
                }, [])
            }).catch(e => {
                console.log(e)
                this.transportNode = []
            })
        },
        loadBatchTransView() {
            this.batchTransView.data.p = ``
            let batchDatas = _.filter(this.batchTransView.data.checkedRow, { enum_specimen_status: 4 })
            if (this.ischecked && batchDatas.length !== 0) {
                this.batchTransView.data.deliverer = this.currentUser.dic_worker_name
                this.batchTransView.data.deliver_date = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                this.batchTransView.data.p = `共转出${batchDatas.length}个，送往病理科`
                this.batchTransView.dialogFormVisible = true
                return
            }
            this.$message.warning(`未选择需要转出的标本`)
        },
        loadChecked({ row }) {
            this.ischecked = row.length !== 0
            this.batchTransView.data.checkedRow = row
        },
        batchDelever(specimen) {
            let r = _.filter(this.batchTransView.data.checkedRow || this.batchTransView.data, { enum_specimen_status: 4 })
            if (r.length == 0) return
            // ACIS-24077标本转运，已核对标本，批量送检操作能标记一起批量送检的标本
            let reqBatch = this.myaxios.get(`api/AcisSystem/SystemServer/CreateSerialNum?name=Specimen`)
            reqBatch.then(data => {
                let reqs = r.map(d => {
                    return this.myaxios.put(`/api/Nursing/Specimen/Deliver`, {
                        id: d.id,
                        deliverer: specimen.deliverer,
                        deliver_date: specimen.deliver_date,
                        enum_specimen_deliver_location: 2, // 2病理科  1标本间
                        biz_surgery_info_id: d.biz_surgery_info_id,
                        batch_no: data
                    })
                })

                this.myaxios.all(...reqs).then(data => {
                    this.$refs[`specimen-list`].ReloadListData()
                    this.batchTransView.dialogFormVisible = false
                })
            })
        },
        printDocument() {
            let list = this.sacnCheckView.data.length == 0 ? this.batchTransView.data.checkedRow : this.sacnCheckView.data
            if (!this.batchTransView.data.checkedRow && !this.ischecked && list.length == 0) {
                this.$message.warning(`未选择打印标本`)
                return
            }
            if (list.length == 0) {
                this.$message.warning(`未选择打印标本`)
                return
            }
            if (list.length > 0) {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT.BLBB001,
                                id1: `999999`,
                                objId: list.map(d => d.id).toString()
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        loadXslx() {
            location.href = `${this.$root.BASE_URL}api/Operation/Home/ExcelFile`
        },
        scanSpecimen() {
            let r = _.filter(this.sacnCheckView.data, { identification_code: this.specimen_id })
            if (!this.specimen_id) {
                this.$message.warning(`扫码号不能为空`)
                return
            }
            if (r.length != 0) {
                this.$message.warning(`该标本已添加`)
                return
            }
            let req = this.myaxios.post(`/api/Nursing/Specimen/Sacn?identificationCode=${this.specimen_id}`)
            req.then(d => {
                d.patient_name = d.surgery_info && d.surgery_info.patient_name
                d.ward = d.surgery_info && d.surgery_info.dic_section
                d.bed_no = d.surgery_info && d.surgery_info.bed_no
                d.visit_no = d.surgery_info && d.surgery_info.visit_no
                d.surgery_info = d.surgery_info && d.surgery_info.dic_operating_room
                this.sacnCheckView.data.push(d)
            }).catch(e => {
                console.log(e)
            })
        },
        batchCheckThrough() {
            let r = _.filter(this.sacnCheckView.data, d => { return d.enum_specimen_status != 4 })
            if (r.length == 0) {
                this.$message.warning(`数据列表中不含有未核对的数据`)
                return false
            }
            let reqs = r.map(d => {
                d.enum_specimen_status = 4
                return this.myaxios.put(`/api/Nursing/Specimen/Check`, d)
            })
            this.myaxios.all(...reqs).then(data => {
                this.$refs[`specimen-list`].ReloadListData()
                // this.sacnCheckView.dialogFormVisible =false
            })
        },
        confirmBatchCheck() {
            this.batchTransView.data.p = ``
            let r = _.filter(this.sacnCheckView.data, { enum_specimen_status: 4 })
            let r1 = _.filter(this.sacnCheckView.data, d => { return d.enum_specimen_status != 4 })
            if (r1.length != 0) {
                this.$message.warning(`存在未核对转出手术间的标本，请核对转出手术间后再操作`)
                return false
            }
            if (r.length == 0) {
                this.$message.warning(`不存在待送检数据`)
                return false
            }
            // console.log(r)
            this.batchTransView.data.checkedRow = r
            this.batchTransView.data.deliverer = this.currentUser.dic_worker_name
            this.batchTransView.data.deliver_date = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            this.batchTransView.data.p = `共转出${r.length}个，送往病理科`
            this.batchTransView.dialogFormVisible = true
        },
        removeScanChckView({ index, row }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.sacnCheckView.data.splice(index, 1)
            })
        }
    },
    watch: {
        dic_ward_id: function() {
            this.$refs[`specimen-list`].ReloadListData()
        },
        rdate: function() {
            this.$refs[`specimen-list`].ReloadListData()
        },
        specimen_status: function() {
            this.$refs[`specimen-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Specimen/Transfer.vue